import Base from './base';
import Manager from './manager';

export default [
    Manager,
    Base
];